import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
    name: 'ColumnSelectorModal',
    components: {}
})
export default class ColumnSelectorModal extends Vue {
    @Prop({ required: true })
    modalId!: string;
    @Prop({ required: true })
    availableColumns!: string[];
    @Prop({ required: true })
    selectedColumns!: string[];

    private get unselectedColumns(): string[] {
        return this.availableColumns.filter(e => !this.selectedColumns.includes(e));
    }

    private close(): void {

    }

    private selectedColumn(item: string): void {
        this.$emit('selectedColumn', item);
    }

    private unselectedColumn(item: string): void {
        this.$emit('unselectedColumn', item);
    }
}